<template>
  <div class="longtermreservation">
    <BaseTitle titleText="預約長照單" />
    <LongTermInitForm
      :deliveryMethodOptions="deliveryMethodOptions"
      :serviceOptions="serviceOptions"
      :orderData="orderData"
      :usersSearchResult="usersSearchResult"
      :userDetailSearchResult="userDetailSearchResult"
      :orderUserLocation="orderUserLocation"
      :userHistoryAddress="userHistoryAddress"
      :orderDriverIDSearchResult="orderDriverIDSearchResult"
      :orderLicenseNumberSearchResult="orderLicenseNumberSearchResult"
      @orderDataHandler="orderDataHandler"
      @getUserOrderData="getUserOrderData"
      @inputOnLocation="inputOnLocation"
      @inputOffLocation="inputOffLocation"
      @searchDriverId="searchDriverId"
      @searchLicenseNumber="searchLicenseNumber"
      @selectDriverId="selectDriverId"
      @selectLicenseNumber="selectLicenseNumber"
      @locationExchange="locationExchange"
      @onSubmit="onSubmit"
      @onReset="onReset"
    />
    <BaseModal id="nextActionModal" @onOk="$router.go(-1)">
      <p slot="modal-content">長照單新增成功，是否返回上一頁？</p>
    </BaseModal>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import LongTermInitForm from '@/components/longTerm/LongTermInitForm';
import BaseModal from '@/components/base/BaseModal';
import { mapGetters, mapActions } from 'vuex';

import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'LongTermReservation',
  components: {
    BaseTitle,
    LongTermInitForm,
    BaseModal
  },
  data() {
    return {
      showOrderUserData: false,
      orderUserLocation: {},
      onLocation: null,
      offLocation: null,
      onLocationGps: [],
      offLocationGps: []
    };
  },
  methods: {
    ...mapActions({
      addOrder: 'longTerm/addOrder',
      fetchUserDetailSearch: 'longTerm/fetchUserDetailSearch',
      fetchOrderDriverSearch: 'longTerm/fetchOrderDriverSearch'
    }),
    orderDataHandler({ value, property }) {
      const data = this.orderData;
      data[property] = value;
      this.$store.commit('longTerm/orderData', data);
    },
    async getUserOrderData(user) {
      try {
        await this.fetchUserDetailSearch(user.id);
        this.orderUserLocation = {
          address: user.address,
          longitude: user.addressGps[0],
          latitude: user.addressGps[1]
        };
        this.$store.commit('longTerm/usersSearchResult', []);
      } catch (err) {
        console.warn(err);
      }
    },
    inputOnLocation(location) {
      // console.log(location);
      const onLocationGps =
        location.longitude && location.latitude
          ? [location.longitude, location.latitude]
          : [];
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        onLocation: location.address,
        onLocationGps
      });
    },
    inputOffLocation(location) {
      const offLocationGps =
        location.longitude && location.latitude
          ? [location.longitude, location.latitude]
          : [];
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        offLocation: location.address,
        offLocationGps
      });
    },
    searchDriverId(value) {
      this.fetchOrderDriverSearch({
        dataType: 'driverId',
        driverData: {
          call_number: value
        }
      });
    },
    searchLicenseNumber(value) {
      this.fetchOrderDriverSearch({
        dataType: 'licenseNumber',
        driverData: {
          license_number: value
        }
      });
    },
    selectDriverId(item) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        driverId: item.id,
        licenseNumber: item.licenseNumber
      });
    },
    selectLicenseNumber(item) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        licenseNumber: item.licenseNumber
      });
    },
    locationExchange() {
      if (!(this.orderData.onLocation && this.orderData.offLocation)) return;
      this.onLocation = {
        onLocation: this.orderData.onLocation,
        onLocationGps: this.orderData.onLocationGps
      };
      this.offLocation = {
        offLocation: this.orderData.offLocation,
        offLocationGps: this.orderData.offLocationGps
      };
      this.orderDataHandler({
        value: this.offLocation.offLocation,
        property: 'onLocation'
      });
      this.orderDataHandler({
        value: this.offLocation.offLocationGps,
        property: 'onLocationGps'
      });
      this.orderDataHandler({
        value: this.onLocation.onLocation,
        property: 'offLocation'
      });
      this.orderDataHandler({
        value: this.onLocation.onLocationGps,
        property: 'offLocationGps'
      });
    },
    orderDataProcess(data) {
      return Object.keys(data).reduce((accu, curr) => {
        if (curr === 'onLocationGps' && !data[curr].length) return accu;
        if (curr === 'offLocationGps' && !data[curr].length) return accu;
        if (curr === 'service' && !data[curr].length) return accu;
        if (curr === 'driverId' && !data[curr]) return accu;
        if (curr === 'licenseNumber' && !data[curr]) return accu;
        if (curr === 'subsidyMethod') return accu;
        if (curr === 'milage') return accu;
        if (curr === 'subsidyFare') return accu;
        if (curr === 'metreFare') return accu;
        if (curr === 'actualFare') return accu;
        if (curr === 'getOnTime') return accu;
        if (curr === 'getOffTime') return accu;
        accu[curr] = data[curr];
        return accu;
      }, {});
    },
    async onSubmit() {
      const data = this.orderDataProcess(this.orderData);

      try {
        await this.addOrder(data);
        // this.$bvToast.toast('長照單新增成功', {
        //   toaster: 'b-toaster-top-center',
        //   variant: 'success',
        //   solid: true
        // });
        this.$root.$emit('bv::show::modal', 'nextActionModal');
      } catch (err) {
        console.warn(err.type);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    onReset() {
      this.$router.go(-1);
    },
    resetForm() {
      this.$store.commit('longTerm/orderData', {
        longTermCareUserId: null,
        deliveryMethod: null,
        estimateGetOnTime: '',
        onLocation: '',
        onLocationGps: [],
        offLocation: '',
        offLocationGps: [],
        seat: null,
        service: [],
        serviceNote: '',
        driverId: null,
        licenseNumber: ''
      });
      this.$store.commit('longTerm/userDetailSearchResult', {
        name: '',
        address: '',
        service: [],
        payForOwnselfProportion: null,
        selfPayRatio: null,
        subsidyLastAmount: null,
        lastCommunityShuttleFrequency: null,
        verification: false,
        historyAddressData: []
      });
      this.$store.commit('longTerm/userHistoryAddress', []);
    }
  },
  computed: {
    ...mapGetters({
      deliveryMethodOptions: 'longTerm/deliveryMethodOptions',
      serviceOptions: 'longTerm/serviceOptions',
      orderData: 'longTerm/orderData',
      usersSearchResult: 'longTerm/usersSearchResult',
      userDetailSearchResult: 'longTerm/userDetailSearchResult',
      orderDriverIDSearchResult: 'longTerm/orderDriverIDSearchResult',
      orderLicenseNumberSearchResult: 'longTerm/orderLicenseNumberSearchResult',
      userHistoryAddress: 'longTerm/userHistoryAddress'
    })
  },
  beforeRouteLeave(_to, _from, next) {
    this.resetForm();
    next();
  }
};
</script>

<style lang="scss" scoped>
.longtermreservation {
  width: 65%;
  max-width: 950px;
  margin: 0 auto;
}
</style>
